import { render, staticRenderFns } from "./StructureSettings.vue?vue&type=template&id=4680d09c&scoped=true&"
import script from "./StructureSettings.vue?vue&type=script&lang=ts&"
export * from "./StructureSettings.vue?vue&type=script&lang=ts&"
import style0 from "./StructureSettings.vue?vue&type=style&index=0&id=4680d09c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4680d09c",
  null
  
)

export default component.exports